module.exports = __webpack_public_path__ + "static/media/CASE.c9b4389d.svg";